import { apiRequest } from '../../shared/api/client.ts';
import type {
  ApiTokenListResponse,
  CreateApiTokenResponse,
  CurrentUser,
  JiraPingResponse,
} from '@lens/shared';

export async function updateProfile(input: {
  displayName: string;
}): Promise<{ ok: boolean; user: CurrentUser }> {
  return apiRequest('/api/auth/me/profile', {
    method: 'PUT',
    body: input,
  });
}

// ─── Смена пароля ──────────────────────────────────────────────────────
// Бэкенд (POST /api/auth/password) проверяет текущий пароль, политику и
// инвалидирует прочие сессии. Возвращает 204 без тела.
export async function changePassword(input: {
  oldPassword: string;
  newPassword: string;
}): Promise<void> {
  await apiRequest('/api/auth/password', {
    method: 'POST',
    body: input,
  });
}

export async function setJiraToken(token: string): Promise<{ ok: boolean }> {
  return apiRequest('/api/auth/me/jira-token', {
    method: 'PUT',
    body: { token },
  });
}

export async function deleteJiraToken(): Promise<{ ok: boolean }> {
  return apiRequest('/api/auth/me/jira-token', { method: 'DELETE' });
}

export async function pingJira(): Promise<JiraPingResponse> {
  return apiRequest('/api/jira/ping');
}

// ─── LLM API Key ───────────────────────────────────────────────────────

export async function setLlmApiKey(apiKey: string): Promise<{ ok: boolean }> {
  return apiRequest('/api/auth/me/llm-api-key', {
    method: 'PUT',
    body: { apiKey },
  });
}

export async function deleteLlmApiKey(): Promise<{ ok: boolean }> {
  return apiRequest('/api/auth/me/llm-api-key', { method: 'DELETE' });
}

export async function pingLlm(): Promise<{ ok: boolean; model?: string; previewText?: string }> {
  return apiRequest('/api/ai/ping', { method: 'POST' });
}

// ─── Avatar ────────────────────────────────────────────────────────────

export async function setAvatar(avatarUrl: string): Promise<{ ok: boolean; avatarUrl: string }> {
  return apiRequest('/api/auth/me/avatar', {
    method: 'PUT',
    body: { avatarUrl },
  });
}

export async function deleteAvatar(): Promise<{ ok: boolean; avatarUrl: null }> {
  return apiRequest('/api/auth/me/avatar', { method: 'DELETE' });
}

export async function listApiTokens(): Promise<ApiTokenListResponse> {
  return apiRequest('/api/auth/tokens');
}

export async function createApiToken(input: {
  name: string;
  expiresInDays?: number | null;
}): Promise<CreateApiTokenResponse> {
  return apiRequest('/api/auth/tokens', { method: 'POST', body: input });
}

export async function revokeApiToken(id: string): Promise<void> {
  await apiRequest(`/api/auth/tokens/${id}`, { method: 'DELETE' });
}
